module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2_jp.504d3b9f6be4c388a49debd425d64bb4.png";